import React, { type PropsWithChildren, useState } from 'react';

import { createSafeContext } from './createSafeContext';
import { UserRole } from '../lib/types';

interface IAuthContext {
  isLoggedIn: boolean;
  setIsLoggedIn: (x: boolean) => void;
  isCheckingLoggedState: boolean;
  setisCheckingLoggedState: (x: boolean) => void;
  role: UserRole[];
  userLogo: string;
  setUserLogo: (x: string) => void;
  setRole: (x: UserRole[]) => void;
  userName: string;
  setUserName: (x: string) => void;
  id: string;
  setId: (x: string) => void;
  isAdmin: () => boolean;
}

const [useAuth, Provider] = createSafeContext<IAuthContext>();

export { useAuth };

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isCheckingLoggedState, setisCheckingLoggedState] = useState<boolean>(true);
  const [role, setRole] = useState<UserRole[] | undefined>();
  const [userLogo, setUserLogo] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [id, setId] = useState<string>('');
  const isAdmin = React.useCallback(() => role?.includes(UserRole.Admin), [role]);

  return (
    <Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        role,
        setRole,
        userLogo,
        setUserLogo,
        userName,
        setUserName,
        isCheckingLoggedState,
        setisCheckingLoggedState,
        id,
        setId,
        isAdmin,
      }}
    >
      {children}
    </Provider>
  );
};
